(function() {
  var configEl = document.querySelector('.kd-orb-config');
  if (!configEl) return;

  document.body.classList.add('kd-custom-orb-page');

  var productVariantId = configEl.dataset.productVariantId;
  var productPrice = parseInt(configEl.dataset.productPrice, 10);
  var productTitle = configEl.dataset.productTitle;

  var textInput = configEl.querySelector('.kd-orb-config__input');
  var counterEl = configEl.querySelector('.kd-orb-config__counter-num');
  var totalAmountEl = configEl.querySelector('.kd-orb-config__total-amount');
  var submitBtn = configEl.querySelector('.kd-orb-config__submit');
  var msgEl = configEl.querySelector('.kd-orb-config__msg');

  textInput.addEventListener('input', function() {
    counterEl.textContent = textInput.value.length;
  });

  function formatMoney(huf) {
    return huf.toLocaleString('hu-HU') + ' Ft';
  }

  function checkedPrice(prefix) {
    var input = configEl.querySelector('input[name^="' + prefix + '"]:checked');
    return input ? (parseInt(input.dataset.ribbonPrice, 10) || 0) : 0;
  }

  function updateTotal() {
    totalAmountEl.textContent = formatMoney(productPrice + checkedPrice('kd-orb-ribbon-') + checkedPrice('kd-orb-box-'));
  }

  configEl.querySelectorAll('input[name^="kd-orb-ribbon-"], input[name^="kd-orb-box-"]').forEach(function(r) {
    r.addEventListener('change', updateTotal);
  });

  function showError(text) { msgEl.textContent = text; msgEl.classList.remove('is-success'); }
  function showSuccess(text) { msgEl.textContent = text; msgEl.classList.add('is-success'); }

  submitBtn.addEventListener('click', function() {
    var text = textInput.value.trim();
    if (text.length === 0) {
      showError('Kérjük írd be a kívánt feliratot.');
      textInput.focus();
      return;
    }
    if (text.length > 30) {
      showError('A felirat max. 30 karakter lehet.');
      textInput.focus();
      return;
    }

    var colorInput = configEl.querySelector('input[name^="kd-orb-color-"]:checked');
    var fontInput = configEl.querySelector('input[name^="kd-orb-font-"]:checked');
    var ribbonInput = configEl.querySelector('input[name^="kd-orb-ribbon-"]:checked');
    var boxInput = configEl.querySelector('input[name^="kd-orb-box-"]:checked');

    var items = [{
      id: productVariantId,
      quantity: 1,
      properties: {
        'Felirat': text,
        'Felirat színe': colorInput ? colorInput.value : '',
        'Betűtípus': fontInput ? fontInput.value : 'Írott'
      }
    }];

    if (ribbonInput && ribbonInput.dataset.ribbonVariantId) {
      items.push({
        id: ribbonInput.dataset.ribbonVariantId,
        quantity: 1,
        properties: {
          'Gömbhöz': productTitle,
          'Szalag színe': ribbonInput.value
        }
      });
    }

    if (boxInput && boxInput.dataset.boxVariantId) {
      items.push({
        id: boxInput.dataset.boxVariantId,
        quantity: 1,
        properties: { 'Gömbhöz': productTitle }
      });
    }

    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;
    showSuccess('Kosárba teszem...');

    function addItem(item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(item)
      }).then(function(response) {
        if (!response.ok) return response.json().then(function(err) { throw err; });
        return response.json();
      });
    }

    items.reduce(function(chain, item) {
      return chain.then(function() { return addItem(item); });
    }, Promise.resolve())
      .then(function() {
        showSuccess('Sikeresen kosárba téve! Átirányítás...');
        setTimeout(function() { window.location.href = '/cart'; }, 600);
      })
      .catch(function(err) {
        console.error('Cart add error:', err);
        var msg = (err && err.description) ? err.description : (err && err.message) ? err.message : 'Hiba történt. Kérjük próbáld újra.';
        showError(msg);
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
      });
  });

  updateTotal();
})();
